/**
 * The client's time zone, for every date this app SHOWS.
 *
 * HRFlex clients are each in one zone (Nigeria today; Ghana and Kenya next), and the API now sends every date with
 * that client's offset. Formatting in the BROWSER's zone - the default - shows a user abroad the wrong time, and near
 * midnight the wrong day. So every display formats in the client's zone instead: the IANA name the client lookup
 * (`/clients/{code}`) returns as `timeZone`, and West Africa Time until it does. Candidates never sign in.
 * HRFlex docs/plans/utc-time-storage.md, L3.
 *
 * The zone is held in this tab's memory, never in localStorage: one localStorage key is shared by every tab of the
 * browser, so opening a second client would re-zone the dates of the first one.
 */
let currentZone = "";
export const DEFAULT_TIME_ZONE = "Africa/Lagos";

const isValidTimeZone = (zone: string): boolean => {
  try {
    new Intl.DateTimeFormat("en", { timeZone: zone });
    return true;
  } catch {
    return false;
  }
};

/** The client's IANA zone: the one the client lookup returned in this tab, else Africa/Lagos. */
export const tenantTimeZone = (): string => {
  return currentZone || DEFAULT_TIME_ZONE;
};

/** Remembers the zone the client lookup returned. Ignores a missing or unknown value. */
export const setTenantTimeZone = (zone?: string | null): void => {
  if (!zone || !isValidTimeZone(zone)) return;
  currentZone = zone;
};
